import React, { Component } from "react";
import "react-vis/dist/style.css";
import {
  XYPlot,
  LineSeries,
  VerticalBarSeries,
  AreaSeries,
  HorizontalBarSeries,
  MarkSeriesCanvas,
  VerticalGridLines,
  HorizontalGridLines,
  XAxis,
  YAxis,
} from "react-vis";
class Charts extends Component {
  render() {
    const data = [
      { x: 0, y: 8 },
      { x: 1, y: 5 },
      { x: 2, y: 4 },
      { x: 3, y: 9 },
      { x: 4, y: 1 },
      { x: 5, y: 7 },
      { x: 6, y: 6 },
      { x: 7, y: 3 },
      { x: 8, y: 2 },
      { x: 9, y: 0 },
    ];
    return (
      <div>
        <div className="card bordered-card is-shadowless">
          <div className="card-content">
            <div className="title has-text-centered">Charts</div>
            <div className="columns">
              <div className="column">
                <div className="d-flex justify-content-center">
                  <XYPlot height={300} width={300}>
                    <VerticalGridLines />
                    <HorizontalGridLines />
                    <XAxis />
                    <YAxis />
                    <MarkSeriesCanvas data={data} />
                  </XYPlot>
                </div>

                <div className="is-size-4 has-text-centered">Sales Report</div>
              </div>

              <div className="column">
                <XYPlot height={300} width={300}>
                  <VerticalGridLines />
                  <HorizontalGridLines />
                  <XAxis />
                  <YAxis />
                  <LineSeries data={data} />
                </XYPlot>
              </div>

              <div className="column">
                <XYPlot height={300} width={300}>
                  <LineSeries data={data} />
                  <VerticalGridLines />
                  <HorizontalGridLines />
                  <XAxis />
                  <YAxis />
                </XYPlot>
              </div>
            </div>

            <div className="columns">
              <div className="column">
                <XYPlot height={300} width={300}>
                  <VerticalBarSeries data={data} />
                  <VerticalGridLines />
                  <HorizontalGridLines />
                  <XAxis />
                  <YAxis />
                </XYPlot>
              </div>

              <div className="column">
                <XYPlot height={300} width={300}>
                  <AreaSeries data={data} />
                  <VerticalGridLines />
                  <HorizontalGridLines />
                  <XAxis />
                  <YAxis />
                </XYPlot>
              </div>

              <div className="column">
                <XYPlot height={300} width={300}>
                  <HorizontalBarSeries data={data} />
                  <VerticalGridLines />
                  <HorizontalGridLines />
                  <XAxis />
                  <YAxis />
                </XYPlot>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Charts;
